export const pathnameWiseName: Record<string, string> = {
  '/sales/list/': 'Sales List',
  '/purchase/list/': 'Purchase List',
  '/sales/order/list/': 'Sales Order List',
  '/sales/return/list/': 'Sales Return List',
  '/purchase/return/list/': 'Purchase Return List',
  '/issues/karigar/list/': 'Issue Karigar List',
  '/issues/refine/list/': 'Issue Refine List',
  '/issues/party/list/': 'Issue Party List',
  '/receives/karigar/list/': 'Receive Karigar List',
  '/receives/refine/list/': 'Receive Refine List',
  '/receives/party/list/': 'Receive Party List',
  '/metal-to/cash/list/': 'Metal to Cash List (Payment)',
  '/receipt/voucher/list/': 'Receipt Voucher List',
  '/journal/voucher/list/': 'Journal Voucher List',
  '/contra/voucher/list/': 'Contra Voucher List',
  '/payment/voucher/list/': 'Payment Voucher List',
  '/accounting/cash-to-metals/list/': 'Metal to Cash List (Receipt)',
  '/accounting/metal-transfer/list/': 'Metal Transfer List',
  '/opening/stock/list/': 'Opening Stock List',
  '/transaction/stock-adjustment/list/': 'Stock Adjustment List',
  '/loan/party-loans/list/': 'Loan Party Loans List',
  '/loan/deals/list/': 'Loan Deals List',
  '/loan/bank-issues/list/': 'Loan Bank Issues List',
  '/loan/interest-receives/list/': 'Loan Interest Receives List',
  '/loan/bank-receives/list/': 'Loan Bank Receives List',
  '/loan/deals/close/list/': 'Loan Deals Close List',
  '/transaction/quotation/list/': 'Quotation List',
};
